import { render, staticRenderFns } from "./alteration-free.vue?vue&type=template&id=961204bc&scoped=true&"
import script from "./alteration-free.vue?vue&type=script&lang=js&"
export * from "./alteration-free.vue?vue&type=script&lang=js&"
import style0 from "./alteration-free.vue?vue&type=style&index=0&id=961204bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961204bc",
  null
  
)

export default component.exports